export const updateDrilldownCategoriesForExport = (chart) => {
    const categories = chart.options.custom?.currentCategories;
    const drilldown = chart.options.custom?.drilldown;
    const title = chart.options.custom?.title.toLowerCase().replace(/\s+/g, '_');
    let filename = `${title}${(drilldown ? `_${drilldown}_drilldown`: '')}`;
    
    if (categories) {
        chart.update({
            xAxis: {
                categories: categories
            }
        });
    }

    chart.update({
        xAxis: {
            type: 'category'
        }
    });
    
    return filename;
}

export const chartExportableOptions = {
    buttons: {
        contextButton: {
          menuItems: [
              'viewFullscreen',
              'printChart',
              'separator',
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG'
          ]
        }
      },
      menuItemDefinitions: {
          // Customize existing menu items
          viewFullscreen: {
              onclick: function () {
                  this.fullscreen.toggle();
              }
          },
          printChart: {
              onclick: function () {
                const filename = updateDrilldownCategoriesForExport(this);
                this.print();
              }
          },
          downloadPNG: {
              onclick: function () {
                const filename = updateDrilldownCategoriesForExport(this);
                this.exportChartLocal({
                    type: 'image/png',
                    filename
                });
              }
          },
          downloadJPEG: {
              onclick: function () {
                const filename = updateDrilldownCategoriesForExport(this);
                this.exportChartLocal({
                  type: 'image/jpeg',
                  filename
                });
              }
          },
          downloadPDF: {
              onclick: function () {
                const filename = updateDrilldownCategoriesForExport(this);
                this.exportChartLocal({
                  type: 'application/pdf',
                  filename
                });
              }
          },
          downloadSVG: {
              onclick: function () {
                const filename = updateDrilldownCategoriesForExport(this);
                this.exportChartLocal({
                  type: 'image/svg+xml',
                  filename
                });
              }
          }
      }
}

export  const getSuffixByStat = (metric, stat) => {
    let suffix = '__avg';
    if (typeof(stat) === 'string' && stat.toLowerCase() === 'max') {
      suffix = (metric.low_good ? '__min' : '__max') ;
    } else if (typeof(stat) === 'string' && stat.toLowerCase() === 'sum') {
      suffix = '__sum';
    }

    return suffix;
  }